import Icon from '../components/Icon.vue'

Icon.register({
  'sort-up': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M279 224h-238c-21.4 0-32.1-25.9-17-41l119-119c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-up.js
// module id = 1929
// module chunks = 0